// components/QuestionRenderer.jsx
import React from 'react';
import ItemIcon from '@components/ItemIcon.jsx';
import itemList from '@data/itemMap.json';

const itemMap = Object.fromEntries(itemList.map(item => [String(item.id), item.name]));

export default function QuestionRenderer({ question }) {
    const raw = question.question;
    const buildMatch = raw.match(/Welche Komponenten benötigt man für den Bau von (\d+)?/);
    if (buildMatch) {
        const id = buildMatch[1];
        const name = itemMap[id] || id;
        return (
            <h2>
                Welche Komponenten benötigt man für den Bau von <strong>{name}</strong>{' '}
                <ItemIcon id={id} />?
            </h2>
        );
    }
    const costMatch = raw.match(/Wie viel Gold kostet (\d+) insgesamt\?/);
    if (costMatch) {
        const id = costMatch[1];
        const name = itemMap[id] || id;
        return (
            <h2>
                Wie viel Gold kostet <strong>{name}</strong>{' '}
                <ItemIcon id={id} /> insgesamt?
            </h2>
        );
    }
    return <h2>{raw}</h2>;
}